// extracted by mini-css-extract-plugin
module.exports = {"EstimateTitle":"Page_EstimateTitle__QyFS_","Container":"Page_Container__EiCds","EstimateAddForm":"Page_EstimateAddForm__j1hUV","EstimateList":"Page_EstimateList__zT50u"};